export default __webpack_public_path__ + "static/media/Anuphan-Regular.7bf1d062.otf";